import { useTranslation } from 'react-i18next';

import { useGlobalUI } from '@/components/GlobalUIProvider';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { Button } from '@electricjs/arc';
import { useGetAssetQuery } from '@/redux/slices/assetApiSlice';
import { CenteredSpinner } from '@common';
import UnlockDeviceModal from '@/components/People/EmployeeProfile/UnlockDeviceModal';
import { isDeviceAsset } from '@/types/assets';

type UnlockDeviceButtonProps = {
  assetId: string;
  employeeName: string;
};

export const UnlockDeviceButton = ({
  assetId,
  employeeName,
}: UnlockDeviceButtonProps) => {
  const { t } = useTranslation('pages');
  const { openModal, closeModal } = useGlobalUI();

  const organizationId = useGetOrganizationId();

  const { data: asset, isLoading: isLoadingAsset } = useGetAssetQuery({
    organizationId: organizationId,
    assetId: assetId,
  });

  if (isLoadingAsset) {
    return <CenteredSpinner />;
  }

  if (!asset || !isDeviceAsset(asset)) {
    return null;
  }

  return (
    <Button
      id="button-unlock-device-health-monitor"
      variant="outline"
      iconBefore="lock-unlocked"
      onClick={() => {
        openModal(
          <UnlockDeviceModal
            deviceAsset={asset}
            employeeName={employeeName}
            onClose={closeModal}
          />
        );
      }}>
      {t('hardware.deviceOverview.healthMonitor.actions.unlockDevice')}
    </Button>
  );
};
